const MUTATION_NAME_SYMBOL = Symbol();
const INTERNAL_STORE_SYMBOL = Symbol();
export function getStateMutationMetadata(mutation) {
    const name = mutation[MUTATION_NAME_SYMBOL];
    return { name };
}
/** @internal */
export function setStateMutationName(mutation, name) {
    mutation[MUTATION_NAME_SYMBOL] = name;
}
/** @internal */
export function isInternalStore(store) {
    return store[INTERNAL_STORE_SYMBOL] === true;
}
/** @internal */
export function setInternalStoreFlag(store) {
    store[INTERNAL_STORE_SYMBOL] = true;
}
//# sourceMappingURL=storeMetadata.js.map